// Renders a translated string where the segment wrapped in ⟦…⟧ markers is
// shown in the primary accent color. Lets each language highlight its own word.
export default function Highlight({ text }: { text: string }) {
  const parts = text.split(/⟦|⟧/);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className="text-primary">{part}</span>
        ) : (
          part
        )
      )}
    </>
  );
}
